<template>
  <div style="height: 100%;width: 100%; display: flex; ">
    <!------------左侧章节目录------------>
    <div style="height: 100%;max-width: 400px; min-width: 400px; border: 1px solid #e5e5e5">
        <div class="leftButton">
          <el-Button style="margin-top: 5px;margin-left: 5px;" @click="showAddChapter = true">添加章节</el-Button>
        </div>
        <div v-for="(item,index) in chapterList" :key="item.id"
             @mouseover="Mouseover(item.id)"
             @mouseleave="Mouseleave()"
             @click="nodeClick(item)"
             :class="previewId === item.id? 'activityStyle' : ''"
             :style="currentChapterId === item.id ? 'background-color: #8eb8f5':''"
             class="leftTab">
          <span style="margin-left: 10px">第{{index + 1}}章 {{ item.name }}</span>
        </div>

    </div>

    <!--右侧章节详情-->
    <div style="flex:1 ;height: 100%; min-width: 900px; padding-left: 5px;">
      <el-tabs type="border-card" v-model="tabName" style="height: 100%; overflow: auto">
        <!----------------章节内容---------------->
        <el-tab-pane label="章节内容" name="chapterDetail">
          <div style="margin: auto; width:1120px">
          <el-form class="chapterInfo" :data="chapterFormData" label-width="120px" style="width:100%">
            <el-row >
              <el-col :span="18">
                <el-form-item label="章节名称" required>
                  <el-input  v-model="chapterFormData.name"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="排序编号" required>
                  <el-input-number :min="0" v-model="chapterFormData.index"></el-input-number>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="课程介绍" required>
              <el-input  type="textarea" :rows="1"
                        v-model="chapterFormData.introduction"></el-input>
            </el-form-item>
            <el-form-item label="视频预览">
              <video
                  style="border: 2px solid #cccccc; object-fit:fill;"
                  id="video"
                  :src="chapterFormData.videoUrl"
                  :controls="true"
                  :height="570"
                  :width="1000">
              </video>
            </el-form-item>
            <el-form-item label="上传/更新视频"  required>
              <kf-file-upload @fileChange="fileChange"
                              accept=".avi,.mov,.rmvb,.rm,.flv,.mp4,.3gp"
                              v-model="chapterFormData.videoId"
                              :init-file="videoList"
                              :item="video"></kf-file-upload>
            </el-form-item>
            <el-form-item>
              <el-button  @click="saveChapterData()">保存</el-button>
              <el-button  @click="delChapter()">删除</el-button>
            </el-form-item>
          </el-form>
          </div>
        </el-tab-pane>

        <!----------------课后习题---------------->
        <el-tab-pane label="课后习题" name="courseChapterQuestion">
          <el-form  style="margin-top: 10px; width: 600px">
            <el-form-item label="及格题数">
              <el-input-number v-model="passCnt" :min="0" ></el-input-number>
              <el-button @click="setPassCnt" style="margin-left: 10px">设置</el-button>
              <el-button style="margin-left: 20px" @click="showCourseQuestionDialog()">添加习题</el-button>
            </el-form-item>
          </el-form>
          <div v-for="(item,index) in courseQuestionList" style="margin-top: 10px;">
            <p>{{ index + 1 }}、<b>（{{ ValueToName(item.question_type) }}）</b>{{ item.topic }}
            </p>
            <el-checkbox-group style="margin-left: 30px" v-if="item.question_type == 'multiple'" v-model="item.answer">
              <el-checkbox v-if="item.option_a" label="option_a" disabled>A.{{ item.option_a }}</el-checkbox><p></p>
              <el-checkbox v-if="item.option_b" label="option_b" disabled>B.{{ item.option_b }}</el-checkbox><p></p>
              <el-checkbox v-if="item.option_c" label="option_c" disabled>C.{{ item.option_c }}</el-checkbox><p></p>
              <el-checkbox v-if="item.option_d" label="option_d" disabled>D.{{ item.option_d }}</el-checkbox><p></p>
              <el-checkbox v-if="item.option_e" label="option_e" disabled>E.{{ item.option_e }}</el-checkbox><p></p>
              <el-checkbox v-if="item.option_f" label="option_f" disabled>F.{{ item.option_f }}</el-checkbox>
            </el-checkbox-group>
            <el-radio-group style="margin-left: 30px" v-if="item.question_type == 'single'" v-model="item.answer">
              <el-radio v-if="item.option_a" label="option_a" disabled>A.{{ item.option_a }}</el-radio><el-col></el-col>
              <el-radio v-if="item.option_b" label="option_b" disabled>B.{{ item.option_b }}</el-radio><el-col></el-col>
              <el-radio v-if="item.option_c" label="option_c" disabled>C.{{ item.option_c }}</el-radio><el-col></el-col>
              <el-radio v-if="item.option_d" label="option_d" disabled>D.{{ item.option_d }}</el-radio>
            </el-radio-group>
            <el-radio-group style="margin-left: 30px" v-if="item.question_type == 'judge'" v-model="item.answer">
              <el-radio label="true" disabled>正确</el-radio>
              <el-radio label="false" disabled>错误</el-radio>
            </el-radio-group>
            <div style="border-bottom: 1px solid #e5e5e5;margin:10px 0 0 20px;">
            <el-button style="margin:0 0 10px 20px" size="small" @click="editCourseQuestion(item)">编辑</el-button>
            <el-button style="margin-bottom: 10px" size="small" @click="delCourseQuestion(item)">删除</el-button>
            </div>
          </div>
        </el-tab-pane>

        <!----------------学习状况---------------->
        <el-tab-pane label="学习状况" name="studyStatus">
          <el-table :data="pageStudyStatusData"
                    style="width: 100%; height: 100%;">
            <el-table-column prop="userName" label="学习用户" width="180"/>
            <el-table-column label="状态" width="180">
              <template #default="scope">
                <div :style="scope.row.status === '已完成'?'color:green;':'color:red;'">{{ scope.row.status }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="updateTime" label="完成时间" width="180"/>
            <el-table-column prop="answerCnt" label="答题次数" width="180"/>
            <el-table-column prop="studyTime" label="学习时长"/>
          </el-table>
          <div style="display: flex;justify-content: flex-end;margin-top: 5px">
            <el-pagination background layout=" sizes, total, prev, pager, next,"
                           :page-sizes="[10,15,20]"
                           :current-page="currentPage"
                           v-model:page-size="pageSize"
                           :total="studyStatusListSize"
                           @size-change="handleSizeChange"
                           @current-change="handleCurrentChange"
                           :small="false"/>
          </div>
        </el-tab-pane>


        <el-tab-pane label="用户评论" name="userComment">
          <div style="text-align: center">
            <el-row style="line-height: 40px;font-size: 16px;width: 200px">
              <el-col :span="10" style="background-color: skyblue; color: white">点赞</el-col>
              <el-col :span="10" style="background-color: coral; color: white">{{ feedbackData.likeCnt }}</el-col>
            </el-row>
          </div>
          <el-table :data="pageCommentData"
              style="width: 100%; height: 100%;margin-top: 5px;">
            <el-table-column align="center" label="操作" width="100">
              <template #default="scope">
                <el-button type="text" @click="deleteComment(scope.row)" size="small">删除</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="user_name" label="用户" width="100"/>
            <el-table-column prop="operation_type" label="评论"/>
            <el-table-column align="center" prop="create_time" label="评论时间" width="150"/>
          </el-table>
          <div style="display: flex;justify-content: flex-end;margin-top: 5px">
            <el-pagination background layout=" sizes, total, prev, pager, next,"
                           :page-sizes="[10,15,20]"
                           :current-page="currentCommentPage"
                           v-model:page-size="commentPageSize"
                           :total="commentListSize"
                           @size-change="commentSizeChange"
                           @current-change="commentCurrentChange"
                           :small="false"/>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!----------------------------------------添加章节----------------------------------------->
    <el-dialog v-model="showAddChapter" title="添加章节" style="width: 600px;height: 300px">
      <el-form style="margin-left: 10%; margin-top: 10px;" label-width="100px">
        <el-form-item label="父节点">
          <el-input style="width: 300px" v-model="this.currentCourseData.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="章节名称" required>
          <el-input style="width: 300px" v-model="chapterName"></el-input>
        </el-form-item>
        <el-form-item label=" ">
          <el-button @click="add()">添加</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!----------------------------------------添加习题---------------------------------------->
    <el-dialog v-model="showAddCourseQuestion" :title="formData.title" width="700px">
      <el-form :data="formData" label-width="100px" style="width: 600px;">
        <el-form-item label="章节名称" required>
          <el-input v-model="this.currentChapter.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="题型" required>
          <el-select v-model="formData.questionType" @change="changeOption()" style="width: 100%">
            <el-option v-for="item in this.questionTypeList" :key="item.value" :value="item.value"
                       :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="题目" required>
          <el-input v-model="formData.topic" type="textarea" :rows="3"></el-input>
        </el-form-item>
        <el-form-item v-if="showOption==='multiple' || showOption === 'single'" label="选项A">
          <el-input v-model="formData.option_a"></el-input>
        </el-form-item>
        <el-form-item v-if="showOption==='multiple' || showOption === 'single'" label="选项B">
          <el-input v-model="formData.option_b"></el-input>
        </el-form-item>
        <el-form-item v-if="showOption==='multiple' || showOption === 'single'" label="选项C">
          <el-input v-model="formData.option_c"></el-input>
        </el-form-item>
        <el-form-item v-if="showOption==='multiple' || showOption === 'single'" label="选项D">
          <el-input v-model="formData.option_d"></el-input>
        </el-form-item>
        <el-form-item v-if="showOption==='multiple'" label="选项E">
          <el-input v-model="formData.option_e"></el-input>
        </el-form-item>
        <el-form-item v-if="showOption==='multiple'" label="选项F">
          <el-input v-model="formData.option_f"></el-input>
        </el-form-item>
        <el-form-item label="答案" required>
          <el-select v-if="updateSelect" v-model="formData.answer" style="width: 100%" :multiple="isMultiple">
            <el-option v-for="item in answerList" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label=" ">
          <el-button v-if="formData.title === '添加习题'" @click="addCourseQuestion()">添加</el-button>
          <el-button v-if="formData.title === '编辑习题'" @click="updateCourseQuestion()">修改</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>

export default {
  name: "CourseChapterDesign",
  props: {
    parentData: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  data() {
    return {
      showAddChapter: false,
      showAddCourseQuestion: false,
      isMultiple: false,
      updateSelect: true,
      tabName: 'chapterDetail',
      showOption: 'multiple',
      previewId: '',
      currentChapterId: '',
      chapterName: '',
      passCnt:0,
      currentPage:1,
      pageSize:10,
      commentPageSize:10,
      currentCommentPage:1,
      commentListSize:0,
      studyStatusListSize:0,
      time: -1,
      feedbackData:{},
      formData: {},
      chapterFormData:{},
      currentChapter: {},
      currentChapterData: {},
      currentCourseData: {},
      pageCommentData:[],
      pageStudyStatusData:[],
      chapterList: [],
      videoList: [],
      courseQuestionList: [],
      answerList: [],
      video: {
        component: 'file_upload',
        limit: 1,
      },

    }
  },
  watch: {
    //监控答案select控件  多选 单选的变化 留到最后再渲染el-select控件
    isMultiple() {
      this.updateSelect = false
      setTimeout(() => {
        this.updateSelect = true
      })
    },
  },
  computed: {
    questionTypeList() {
      return this.$store.getters['core/getDictList']('question_type');
    },
  },
  created() {
    this.getCourseDetail();

  },
  methods: {
    //左侧章节 鼠标悬浮样式调节
    Mouseover(id) {
      this.previewId = id
    },
    Mouseleave() {
      this.previewId = 'false'
    },
    //分页数据
    handleSizeChange(val) {
      this.pageSize = val
      this.getCurrentPageData();
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getCurrentPageData();
    },
    commentSizeChange(val) {
      this.commentPageSize = val
      this.getCurrentPageData();
    },
    commentCurrentChange(val) {
      this.currentCommentPage = val
      this.getCurrentPageData();
    },
    //分页数据获取 用户评论 学习状况
    getCurrentPageData(){
      if(!this.feedbackData){
        return
      }
      //学习状况
      if(!this.feedbackData.studyStatusData){
        return this.pageStudyStatusData = [];
      }
      this.studyStatusListSize = this.feedbackData.studyStatusData.length;
      var startIndex = (this.currentPage - 1) * this.pageSize;
      var endIndex = this.currentPage * this.pageSize;
      this.pageStudyStatusData = this.feedbackData.studyStatusData.slice(startIndex, endIndex)

      //用户评论
      if(!this.feedbackData.commentData){
        return this.pageCommentData = [];
      }
      this.commentListSize = this.feedbackData.commentData.length;
      var startCommentIndex = (this.currentCommentPage - 1) * this.commentPageSize;
      var endCommentIndex = this.currentCommentPage * this.commentPageSize;
      this.pageCommentData = this.feedbackData.commentData.slice(startCommentIndex, endCommentIndex)

    },

    //获取章节
    async getCourseDetail() {
      this.currentCourseData = this.parentData;
      this.currentCourseData.isMyStudy = false;
      this.chapterList = await this.$http('ihtCourseService.getChapter', this.currentCourseData)
      console.log('chapterList=',this.chapterList)
      this.showOption = 'single';
      this.tabName = 'chapterDetail';
      console.log(this.chapterList)
      if(this.chapterList.length !== 0){
        if(this.currentChapter.id){
          this.nodeClick(this.currentChapter)
          return;
        }
        this.nodeClick(this.chapterList[0])
      }
    },
    //左侧树 点击node方法
    nodeClick(treeNode) {
      this.tabName = 'chapterDetail';
      this.currentChapterId = treeNode.id;
      this.previewId = treeNode.id
      if (treeNode != this.currentChapter ) {
        this.currentChapterData = {};
        this.formData = {};
      }
      this.currentChapter = treeNode;
      this.getCurrentChapterDetail(treeNode);
    },
    //获取章节的详细信息
    async getCurrentChapterDetail(currentChapter) {
      this.currentChapterData = await this.$http('ihtCourseService.getChapterDetail', currentChapter);
      //及格题数
      this.passCnt = this.currentChapterData.pass_question_cnt;
      //习题信息
      this.courseQuestionList = this.currentChapterData.courseQuestionList;
      //视频列表
      this.videoList = this.currentChapterData.videoList;
      //给章节内容form表单赋值
      this.chapterFormData.name = this.currentChapter.name
      this.chapterFormData.id = this.currentChapterData.id
      this.chapterFormData.course_catalog_id = this.currentChapterData.course_catalog_id
      this.chapterFormData.introduction = this.currentChapterData.introduction
      this.chapterFormData.videoUrl = this.currentChapterData.videoUrl
      this.chapterFormData.videoId = this.currentChapterData.videoId
      this.chapterFormData.index = this.currentChapterData.index
      //反馈信息
      this.feedbackData = this.currentChapterData.feedbackData;

      this.getCurrentPageData();
    },

    async fileChange(ids) {
      if (ids.length <= 0) {
        this.time = -1;
        this.chapterFormData.videoUrl = '';
        return;
      }
      let params = {ids: ids}
      var url = await this.$http('ihtCourseService.getUploadUrl', params);
      this.getDurationByUrl(url);

      this.chapterFormData.videoUrl = url;
      this.chapterFormData.videoId = ids;

    },
    //获取该视频的播放时长
    getDurationByUrl(url) {
      var audioElement = new Audio(url);
      var duration;
      var minute;
      var second;
      let that = this;
      audioElement.addEventListener("loadedmetadata",
          function () {
            duration = audioElement.duration; //时长为秒
            minute = parseInt(duration / 60);
            second = parseInt(duration % 60);
            if (second < 10) {
              second = '0' + second;
            }
            that.time = minute + ':' + second;
          });
    },
    //添加章节 展示dialog
    async showCourseQuestionDialog() {
      this.showAddCourseQuestion = true;
      this.formData = {}
      this.formData.title = '添加习题'
    },
    //添加章节 dialog中的添加
    async add() {
      if (!this.currentCourseData.id) {
        this.$message.error('父节点为空!')
        return;
      }
      if (!this.chapterName) {
        this.$message.error('章节名称为空!')
        return;
      }
      let params = {courseId: this.currentCourseData.id, chapterName: this.chapterName}
      await this.$http('ihtCourseService.addChapter', params)
      this.showAddChapter = false;
      this.chapterName = '';
      this.$message.success('添加成功')
      await this.getCourseDetail()

    },
    //保存章节数据
    async saveChapterData() {
      if (!this.chapterFormData.name) {
        this.$message.error('章节名称为空')
        return;
      }if (!this.chapterFormData.introduction) {
        this.$message.error('课程介绍为空')
        return;
      }
      if (!this.chapterFormData.videoId) {
        this.$message.error('视频id为空')
        return;
      }
      if (!this.chapterFormData.index) {
        this.$message.error('排序编号为空')
        return;
      }
      if (this.time == -1) {
        this.$message.error('未获取到视频时长')
        return;
      }
      let params = {chapterFormData: this.chapterFormData, courseId: this.currentCourseData.id, duration: this.time}
      await this.$http('ihtCourseService.editChapter', params);
      await this.getCourseDetail()
      this.$message.success('保存成功')

    },
    //删除章节
    async delChapter() {
      this.$confirm('你确定要删除这个章节及章节所有数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.$http('ihtCourseService.delChapter', this.currentChapter)
        this.currentChapter = {};

        this.currentCourseData = {}
        this.passCnt = 1;
        //习题信息
        this.courseQuestionList = [];
        //视频列表
        this.videoList = [];
        //章节内容form表单
        this.chapterFormData = {}
        //反馈信息
        this.$message.success('删除成功')
        await this.getCourseDetail()

      });
    },
    //题型value name转换
    ValueToName(value) {
      for (const questionTypeObj of this.questionTypeList) {
        if (value == questionTypeObj.value) {
          return questionTypeObj.name;
        }

      }
    },
    //设置及格题数
    async setPassCnt(){
      if (!this.currentChapter.name) {
        this.$message.error('未选择章节点')
        return ;
      }
      if (!this.currentChapter.name) {
        this.$message.error('未选择章节点')
        return ;
      }
      if(!this.passCnt){
        this.$message.error('请填写及格题数')
        return ;
      }
      if(this.passCnt == 0){
        this.$message.error('及格题数不能为0')
        return ;
      }
      if(this.courseQuestionList.length < this.passCnt){
        this.$message.error('及格题数不能大于该章节习题数量')
        return ;
      }
      let params = {chapterId: this.currentChapterData.id, passCnt:this.passCnt, questionSize:this.courseQuestionList.length}
      await this.$http('ihtCourseService.editChapterPassCnt',params)
      await this.getCurrentChapterDetail(this.currentChapter)
      this.$message.success('设置成功')

    },
    //添加习题
    async addCourseQuestion() {
      //输入项检查
      var checkResult = this.checkFormData();
      if (!checkResult) {
        return;
      }
      let params = {currentChapterData: this.currentChapterData, formData: this.formData, questionSize:this.courseQuestionList.length}
      await this.$http('ihtCourseQuestionService.addCourseQuestion', params)
      this.$message.success('添加成功')
      this.formData = {}
      await this.getCurrentChapterDetail(this.currentChapter)
      this.showAddCourseQuestion = false;
    },
    //编辑习题 赋值 展示dialog
    editCourseQuestion(item) {
      this.showAddCourseQuestion = true;
      this.formData = {}
      this.formData.questionType = item.question_type
      this.changeOption();
      this.formData.topic = item.topic
      this.formData.option_a = item.option_a
      this.formData.option_b = item.option_b
      this.formData.option_c = item.option_c
      this.formData.option_d = item.option_d
      this.formData.option_e = item.option_e
      this.formData.option_f = item.option_f
      this.formData.answer = item.answer
      this.formData.id = item.id
      this.formData.title = '编辑习题'

    },
    //修改习题
    async updateCourseQuestion() {
      var checkResult = this.checkFormData();
      if (!checkResult) {
        return;
      }
      if (!this.formData.id) {
        this.$message.error('请点击编辑后修改')
        return;
      }
      await this.$http('ihtCourseQuestionService.updateCourseQuestion', this.formData)
      this.$message.success('修改成功')
      this.formData = {}
      await this.getCurrentChapterDetail(this.currentChapter)
      this.showAddCourseQuestion = false;
    },
    //删除习题
    async delCourseQuestion(item) {
      this.$confirm('你确定要删除这道题吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.$http('ihtCourseQuestionService.delCourseQuestion', item)
        await this.getCurrentChapterDetail(this.currentChapter);
        this.$message.success('删除习题成功')
      });

    },
    //删除评论
    async deleteComment(row){
      this.$confirm('你确定要删除这条评论吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
      let params = {id: row.id}
      await this.$http('ihtStudyTaskService.deleteComment',params)
      await this.getCurrentChapterDetail(this.currentChapter);
      this.$message.success('删除成功')
    })
    },
    checkFormData() {
      if (!this.currentChapter.name) {
        this.$message.error('未选择章节点')
        return false;
      }
      if (!this.formData.topic) {
        this.$message.error('题目为空')
        return false;
      }
      if (!this.formData.questionType) {
        this.$message.error('题型为空')
        return false;
      }
      if (this.showOption == 'multiple' || this.showOption == 'single') {
        if (!this.formData.option_a) {
          this.$message.error('选项A为空')
          return false;
        }
        if (!this.formData.option_b) {
          this.$message.error('选项B为空')
          return false;
        }
        if (!this.formData.option_c) {
          this.$message.error('选项C为空')
          return false;
        }
        if (!this.formData.option_d) {
          this.$message.error('选项D为空')
          return false;
        }
      }
      if (!this.formData.answer) {
        this.$message.error('答案为空')
        return false;
      }
      return true;
    },
    //题型变化 答案候选跟着变
    changeOption() {
      if (this.formData.questionType === 'single') {
        this.formData.answer = '';
        this.showOption = 'single'
        this.answerList = [];
        this.answerList = [{value: 'option_a', label: 'A'},
          {value: 'option_b', label: 'B'},
          {value: 'option_c', label: 'C'},
          {value: 'option_d', label: 'D'}]
        this.isMultiple = false;
      }
      if (this.formData.questionType === 'multiple') {
        this.formData.answer = [];
        this.showOption = 'multiple';
        this.answerList = [];
        this.answerList = [{value: 'option_a', label: 'A'},
          {value: 'option_b', label: 'B'},
          {value: 'option_c', label: 'C'},
          {value: 'option_d', label: 'D'},
          {value: 'option_e', label: 'E'},
          {value: 'option_f', label: 'F'}]
        this.isMultiple = true;
      }
      if (this.formData.questionType === 'judge') {
        this.formData.answer = '';
        this.showOption = 'judge'
        this.answerList = [];
        this.answerList = [{value: 'true', label: '正确'}, {value: 'false', label: '错误'}]
        this.isMultiple = false;
      }
    },

    //@canplay
    // getCurrentData(){
    //   var video = document.getElementById("video");
    //   var sym;
    //==================点击进度条不可快进 回滚进度条代码块
    //   setInterval(function () {
    //     var time=video.currentTime
    //     if(time-sym>1){
    //       video.currentTime=sym
    //
    //     }
    //     sym=video.currentTime
    //   },500);
    // },

  }
}
</script>

<style scoped>
.activityStyle {
  cursor: pointer;
  background-color: #e5e5e5;
}

.leftTab {
  line-height: 40px;
  font-size: 18px;
  cursor: pointer;
  margin-left: 10px;
  margin-right: 10px;
}
.leftButton{
  width: 100%;
  height: 42px;
  margin-bottom: 10px;
  background-color: #ecebeb;
}

:deep(.chapterInfo .el-form-item){
  margin-bottom: 5px;
}

</style>